import {itemWithoutCombinedListingWithoutAdditionalRibbons} from './itemWithoutCombinedListingWithoutAdditionalRibbons';

export const query = `query getRelatedProductsByAlgorithmWithoutCombinedListingWithoutAdditionalRibbons($productIds: [String!]!, $algorithm: Algorithm, $externalId: String!, $withOptions: Boolean = false, $withPriceRange: Boolean = false) {
  appSettings(externalId: $externalId) {
    widgetSettings
  }
  catalog {
    isCatalogV3
    relatedProducts(productIds: $productIds, algorithm: $algorithm) {
      ${itemWithoutCombinedListingWithoutAdditionalRibbons}
    }
  }
}
`;
